import { firebaseDB } from '@/config/firebaseConfig'

const state = {
  customers: {}
}

const mutations = {
  'ADD_CUSTOMER' (state, payload) {
    state.customers[payload.key] = payload.data
  },
  'CLEAR_CUSTOMERS' (state) {
    state.customers = {}
  }

}

const actions = {
  async getCustomer ({ commit }, key) {
    return new Promise((resolve, reject) => {
      firebaseDB().ref('customers').child(key).on('value', customer => {
        if (customer) {
          commit('ADD_CUSTOMER', { key: key, data: customer.val() })
          resolve(customer.val())
        } else {
          reject(new Error('customer not found'))
        }
      })
    })
  }
}

const getters = {
  customers: state => state.customers
}

export default {
  state,
  mutations,
  actions,
  getters
}
